module.exports = __webpack_public_path__ + "assets/images/extra-02.3ebd098fdddc83169f11ee0e4ca1c19e.svg";